import { $ } from '@/libs/jquery/index'

export class LinkBlockHelper {
  public base: JQuery | null = null

  private readonly selectors: ISelectors = {
    base: '[data-selector="isLinkItem"]',
  }

  constructor() {
    this.base = $(this.selectors.base)

    if (this.base.length) {
      this.init()
    }
  }

  public init(): void {
    this.base.on('click', (e) => {
      e.preventDefault()
      const target = $(e.currentTarget).data('href')
      window.location.href = target
    })
  }
}
